import React from "react";

/** Light halo behind emphasized read-only checkboxes (Section / Step / Substep audit preview). */
export const ACCENT_READ_ONLY_CHECKBOX_HIGHLIGHT_WRAP_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 0,
  boxSizing: "border-box",
  flexShrink: 0,
  padding: "3px",
  borderRadius: "6px",
  backgroundColor: "#99C1FE",
};

/**
 * Read-only audit/tree checkboxes: same pattern as InlineCheckbox (readOnly + blue-checkbox + accentColor).
 */
export default function AccentReadOnlyCheckbox({
  checked,
  onChange,
  readOnlyVisual = false,
  /** Title-matched audit row: full-opacity accent + tight wrap, accent border/bg @ partial opacity. */
  emphasizeChecked = false,
  style = {},
  ...rest
}) {
  if (readOnlyVisual) {
    const dimOpacity = checked ? 0.6 : 0.5;
    const inputStyle = {
      width: "18px",
      height: "18px",
      flexShrink: 0,
      cursor: "default",
      pointerEvents: "auto",
      accentColor: "#0d6efd",
      opacity: emphasizeChecked && checked ? 1 : dimOpacity,
    };
    const inputEl = (
      <input
        type="checkbox"
        readOnly
        checked={!!checked}
        className="blue-checkbox"
        style={
          emphasizeChecked && checked ? inputStyle : { ...inputStyle, ...style }
        }
        {...rest}
      />
    );
    if (emphasizeChecked && checked) {
      return (
        <span style={{ ...ACCENT_READ_ONLY_CHECKBOX_HIGHLIGHT_WRAP_STYLE, ...style }}>
          {inputEl}
        </span>
      );
    }
    return inputEl;
  }
  return (
    <input
      type="checkbox"
      checked={!!checked}
      onChange={onChange}
      style={{
        width: "18px",
        height: "18px",
        flexShrink: 0,
        cursor: "pointer",
        opacity: 1,
        ...style,
      }}
      {...rest}
    />
  );
}
